export const ORDER_SIDE = {
  buy: 'BUY',
  sell: 'SELL'
}

export const ORDER_TYPE_MAP = {
  limit: 'LIMIT',
  postOnly: 'POST_ONLY',
  immediateOrCancel: 'IOC',
  fillOrKill: 'FOK',
  market: 'MARKET',
  bestAsk: 'ASK',
  bestBid: 'BID'
}

export const MARKET_ORDER_TYPE_LIST = [
  ORDER_TYPE_MAP.market,
  ORDER_TYPE_MAP.bestAsk,
  ORDER_TYPE_MAP.bestBid
]

export const ORDER_TYPE_LIST = [ORDER_TYPE_MAP.limit, ORDER_TYPE_MAP.market]

export const ORDER_TYPE_LIMIT = 'Limit'

export const ORDER_TYPE_MARKET = 'Market'

export const ORDER_TYPE_TEXT_MAP = {
  LIMIT: ORDER_TYPE_LIMIT,
  POST_ONLY: ORDER_TYPE_LIMIT,
  IOC: ORDER_TYPE_LIMIT,
  FOK: ORDER_TYPE_LIMIT,
  MARKET: ORDER_TYPE_MARKET,
  ASK: ORDER_TYPE_MARKET,
  BID: ORDER_TYPE_MARKET
}

export const ORDER_STATUS_TEXT_MAP = {
  NEW: 'open'
}

export const ORDER_INPUT_MAP = {
  price: 'price',
  size: 'size',
  total: 'total'
}

export const ORDER_LIST_HEADER_COLUMNS = [
  {
    key: 'symbol',
    title: 'Market',
    align: 'left',
    customClass: ['market-column'],
    defaultSortingOrder: 'ascending'
  },
  {
    key: 'order_type',
    title: 'Order type',
    align: 'left',
    isSortable: false
  },
  {
    key: 'side',
    title: 'Side',
    align: 'left',
    defaultSortingOrder: 'ascending'
  },
  {
    key: 'average_executed_price',
    title: 'Filled price',
    align: 'right',
    defaultSortingOrder: 'descending',
    isFilledOrderData: true
  },
  {
    key: 'price',
    title: 'Price',
    align: 'right',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'executed',
    title: 'Filled size',
    align: 'right',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'quantity',
    title: 'Size',
    align: 'right',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'order_value',
    title: 'Value',
    align: 'right',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'type',
    title: 'Post only',
    align: 'left',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'reduce_only',
    title: 'Reduce only',
    align: 'left',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'visible',
    title: 'Hidden',
    align: 'left',
    defaultSortingOrder: 'descending'
  },
  {
    key: 'created_time',
    title: 'Date',
    align: 'right',
    defaultSortingOrder: 'descending',
    isFilledOrderData: false
  },
  {
    key: 'updated_time',
    title: 'Date',
    align: 'right',
    defaultSortingOrder: 'descending',
    isFilledOrderData: true
  }
]
